"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _wolfy87Eventemitter = _interopRequireDefault(require("wolfy87-eventemitter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// Maintain a static reference to emitters by key.
var emitters = {};
/**
 * Create an event emitter by channel. Multiple instances across different package / files can
 * share the same channel and pass events to each other.
 */

var ChannelEventEmitter = /*#__PURE__*/function () {
  function ChannelEventEmitter() {
    var channel = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'default';

    _classCallCheck(this, ChannelEventEmitter);

    var emitter = emitters[channel];

    if (!emitter) {
      emitter = new _wolfy87Eventemitter["default"]();
      emitters[channel] = emitter;
    }

    this.emitter = emitter;
    this.channel = channel;
  }

  _createClass(ChannelEventEmitter, [{
    key: "on",
    value: function on(event) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ChannelEventEmitter.noop;
      this.emitter.on(event, callback);
    }
  }, {
    key: "once",
    value: function once(event) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ChannelEventEmitter.noop;
      this.emitter.once(event, callback);
    }
  }, {
    key: "off",
    value: function off(event) {
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ChannelEventEmitter.noop;
      this.emitter.off(event, callback);
    }
  }, {
    key: "trigger",
    value: function trigger(event, data) {
      this.emitter.trigger(event, [data]);
    }
  }, {
    key: "removeAll",
    value: function removeAll(event) {
      this.emitter.removeAllListeners(event);
    }
  }], [{
    key: "noop",
    value: function noop() {}
  }]);

  return ChannelEventEmitter;
}();

exports["default"] = ChannelEventEmitter;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/events/lib/channel-event-emitter.js
// module id = 146
// module chunks = 0 1